import React, {Component} from 'react';
import '../../style/Card.css'

export default class Card extends Component {
    constructor(props){
        super(props)
        this.state = {}
    }

    render() {
        return(
            <div className='card'>
                <div className='title'>{this.props.title}</div>
                <div className='card-container'>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
